import { Paper, Popper } from "@mui/material";
import { makeStyles } from "components/providers/makeStyles";
import { useEffect, useRef, useState } from "react";

import { useEventSearch } from "../../../../hooks/useEventSearch";
import { SearchForm } from "../../../search/search";
import { EventSearchResults } from "./EventSearchResults";

const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(1),
    },
    searchForm: {
        marginBottom: theme.spacing(4),
    },
}));
export const EventSearchDesktop = ({ event }) => {
    const {
        inputRef,
        loading,
        searchString,
        onSearch,
        clearSearch,
        searchResults,
    } = useEventSearch(event);
    const classes = useStyles();
    const searchFormRef = useRef();
    const [maxHeight, setMaxHeight] = useState(0);

    useEffect(() => {
        const updateHeight = () =>
            inputRef.current &&
            setMaxHeight(
                window.innerHeight -
                    (inputRef.current.getBoundingClientRect().top + 96),
            );
        updateHeight();
        window.addEventListener("resize", updateHeight);
        return () => window.removeEventListener("resize", updateHeight);
    }, []);

    return (
        <>
            <SearchForm
                searchFormRef={searchFormRef}
                className={classes.searchForm}
                inputRef={inputRef}
                search={searchString}
                onChange={onSearch}
                loading={loading}
                placeholder="Find competitors or divisions"
            />
            <Popper
                open={!!searchString}
                anchorEl={searchFormRef.current}
                placement="bottom-start"
                style={{
                    zIndex: 10,
                    width: searchFormRef.current
                        ? searchFormRef.current.clientWidth
                        : "auto",
                }}
            >
                <Paper
                    elevation={3}
                    className={classes.paper}
                    style={{ maxHeight: maxHeight || "auto" }}
                >
                    <EventSearchResults
                        eventId={event.id}
                        clearSearch={clearSearch}
                        searchResults={searchResults}
                        loading={loading}
                        maxHeight={maxHeight}
                        padding={16}
                    />
                </Paper>
            </Popper>
        </>
    );
};
